<template>
	<div class="main_content">
    <!-- Modal windows -->
    <CreateTask
      ref="createTaskModal"
      :title="'Добавить новую задачу'"
      :tasks="schedule.tasks"
      @add-task="createTask" />
    
    <EditPlaylistTask
      ref="editPlaylistModal"
      :files="files"
      :disableDefaultTask="schedule.hasDefaultTask"
      :tasks="schedule.tasks"
      :highlightedTask="highlightedTask"
      :tDuration = "tDuration"
      @update-task="updateTask"
      />
    <EditURLTask
      ref="editURLModal"
      :tasks="schedule.tasks"
      :disableDefaultTask="schedule.hasDefaultTask"
      :highlightedTask="highlightedTask"
      @update-task="updateTask"
      />
    <EditSleepTask
      ref="editSleepModal"
      :tasks="schedule.tasks"
      :disableDefaultTask="schedule.hasDefaultTask"
      :highlightedTask="highlightedTask"
      @update-task="updateTask"
      />
    <ConfirmModal
      ref="saveWarningModal"
      title="Предупреждение"
      text="Расписание было изменено, вы действительно хотите продолжить без сохранения"
      okText="Продолжить без сохранения"
      cancelText="Вернуться к редактированию"
      @confirm="leaveWithoutSave"
      />

<!--    <Header :title="'Редактирование плейлиста '+ title">-->
<!--      <button class="btn" @click="openModal('createTaskModal', null)">Добавить задачу</button>-->
<!--      <button class="btn" :class="{'btn-primary': scheduleUpdated}" @click="saveSchedule">Сохранить плейлист</button>-->
<!--    </Header>-->
    <div class="schedule-name">
      <h3>Конструктор расписания</h3>
    </div>
    <div v-show="!hideContent" class="content">
      <!-- icon list -->
      <div class="editor-column editor-column-info">
        <div
          v-for="(task, i) in formattedTasks"
          :key="i"
          class="list-item"
          @click="openTask(task.realTask, i)"
        >
          <div class="list-item-icon" :style="{'background-image': 'url(' + task.icon + ')'}"></div>
          <div class="list-item-caption">
            <div>{{task.taskName}}</div>
            <div><b>{{ task.name }}</b></div>
<!--            <div v-for="line in task.description">{{ line }}</div>-->
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-caption"><b>Общий график</b></div>
        </div>
      </div>
      <!-- chart -->
      <div class="chart-container">
        <ScheduleChart
          :schedule="schedule"
          :highlighted="highlightedTask"
          :files="files"
          @set-highlight="setHighlight"
          @open-task-modal="openModal('createTaskModal',null)"
          @open-editor="openStatisticsWindow"
          v-model="hideContent"
        ></ScheduleChart>
      </div>
      <!-- actions list -->
      <div v-if="openStatistics===false" >
        <div class="editor-column editor-column-actions">
          <div
              v-for="(task, i) in formattedTasks"
              :key="i"
              class="list-item"
              @click="openStatisticsWindow()"
              @mouseenter="setHighlight(i)"
              @mouseleave="unsetHighlight(i)"
          >
            <div  class="list-item-buttons">
              <template v-if="!task.isDefault">
                <button @click.stop="increasePriority(i)" type="button"><img src="/static/icons/down.svg"></button>
                <button @click.stop="decreasePriority(i)" type="button"><img src="/static/icons/up.svg"></button>
              </template>
              <button @click.stop="openTask(task.realTask, i)" type="button" title="Изменить"><img src="/static/icons/rename.svg"></button>
              <button @click.stop="removeTask(task.realTask)" type="button" title="Удалить"><img src="/static/icons/delete.svg"></button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="sidebar-container">
        <TaskStatistics :task="currentTask" :is-open="openStatistics" @edit-task="openTask(currentStatisticsTask, selectedTaskIndex)" @close-window="closeStatisticsWindow"></TaskStatistics>
      </div>
<!--      <div class="sidebar-container">-->
<!--        <EditSchedule/>-->
<!--      </div>-->
    </div>
    <div
    v-show="hideContent"
    class="schedule-name"
    >
      <h3>Настройка расписаний не поддерживается на вашем устройстве</h3>
    </div>
	</div>
</template>

<script>
import { reactive } from 'vue'

import CreateModal from '@/components/CreateModal.vue'
import Header from '@/components/Header.vue'
import EditPlaylistTask from '@/components/PlayList/EditPlaylistTask.vue'
import CreateTask from '@/components/PlayList/CreateTask.vue'
import {formatAmountMinutes, formatAmountMinutesSeconds} from '@/utils/formatters'
import {
  Schedule,
  PlaylistTask,
  SleepTask,
  VideoTask,
  SlideshowTask,
  DocumentTask,
  StreamTask,
  WebTask,
  DailyTime,
  URLTask,
  PlayUntilTime,
  DefaultSchedule,
  PeriodicTime,
  PlayUntilCompleted, 
} from '@/api/ScheduleModel'
import ViewWithModalsMixin from '@/mixins/ViewWithModalsMixin'
import EditURLTask from '@/components/PlayList/EditURLTask.vue'
import EditSleepTask from '@/components/PlayList/EditSleepTask.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'
import ScheduleChart from '@/components/ScheduleChart.vue'
import TaskStatistics from '@/components/PlayList/TaskStatistics.vue'
import { formatAmount } from '@/utils/formatters'
import EditSchedule from "@/components/Schedule/EditSchedule.vue";
import { range, multirange, checkOverlap } from '@/utils/range-utils'

export default {
  name: 'ScheduleEditor',
  inject: ['schedulesAPI', 'filesAPI', 'messagePopup'],
  mixins: [ViewWithModalsMixin],
  components: {
    EditSchedule,
    TaskStatistics,
    CreateModal,
    Header,
    CreateTask,
    EditPlaylistTask,
    EditURLTask,
    EditSleepTask,
    ConfirmModal,
    ScheduleChart,
  },
  data: () => ({
    scheduleUpdated: false,
    schedule: reactive(new Schedule()),
    files: [],
    currentTask:null,
    currentStatisticsTask:null,
    openStatistics: false,
    title: '',
    highlightedTask: null,
    selectedTaskIndex: null,
    hideContent: false,
    tDuration: 0
  }),
  mounted() {
    this.fetchSchedule()
    this.fetchFiles()
    window.addEventListener('beforeunload', this.unloadHandler);
  },
  unmounted() {
    window.removeEventListener('beforeunload', this.unloadHandler);
  },
  computed: {
    currentSchedule: function() {
        return this.$route.params.id;
    },
    formattedTasks: function(){
      return this.schedule.tasks.map((t) => {
        let description;
        if(t instanceof PlaylistTask) {
          let size = t.calculateSize(this.files);
          let duration = t.calculateDuration(this.files);
          this.tDuration = duration;
          let dsec = duration % 60;
          let dmin = Math.floor(duration / 60);
          description = [
              formatAmount(size, 'элемент', 'элемента', 'элементов'),
              `Продолжительность: ${dmin < 10 ? '0' + dmin : dmin}:${dsec < 10 ? '0' + dsec : dsec}`
          ];
        } else {
          description = [t.url];
        }
        return {
          icon: this.getTaskIcon(t),
          name: t.label,
          taskName: t.taskName,
          description: description,
          isDefault: t.schedule instanceof DefaultSchedule,
          schedule: t.schedule.toString(),
          realTask: t
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    if(this.scheduleUpdated) {
      this.openModal('saveWarningModal', next);
    } else {
      next();
    }
  },
  methods: {
    getClips: function(){
      return this.schedule.tasks.map((task,index) => {
        let start = 0;
        let end = 0;
        let repeat = null;
        let dayLength = 24*60;
        let duration = 0;
        let type;
        if(task.schedule instanceof DefaultSchedule){
          start = 0;
          end = dayLength;
          type="default"
        } else if(task.schedule instanceof PlayUntilTime){
          start = (task.schedule.start instanceof DailyTime || task.schedule.start instanceof PeriodicTime) ? (task.schedule.start.hour * 60 + task.schedule.start.minutes) : task.schedule.start.minutes;
          end = (task.schedule.end instanceof DailyTime || task.schedule.start instanceof PeriodicTime) ? (task.schedule.end.hour * 60 + task.schedule.end.minutes) : task.schedule.end.minutes;
        }
        else if(task.schedule instanceof PeriodicTime) {
                        repeat = task.schedule.repeat;
                        start = (task.schedule.start.hour * 60 + task.schedule.start.minutes);
                        duration = task.schedule.duration;
                        end = 0;
                        switch(task.schedule.repeat){
                        case 60:{
                            type = 'hourly';
                            repeat = 60;
                            break;
                        }
                        case 30:{
                            type = 'halfHourly'
                            repeat = 30;
                            break;
                        }
                        case 15:{
                            type = 'quarterHourly'
                            repeat = 15;
                            break;
                        }
                        case 10:{
                            type = 'sixthPartHourtlyTime'
                            repeat = 10;
                            break;
                        }
                        case 5:{
                            type = 'twelfthPartHourtlyTime'
                            repeat = 5;
                            break;
                        }
                    }
                }
          else if(task.schedule instanceof PlayUntilCompleted){
          start = (task.schedule.start instanceof DailyTime) ? (task.schedule.start.hour * 60 + task.schedule.start.minutes) : task.schedule.start.minutes;
          end = start + Math.floor(task.calculateDuration(this.files) / 60);
        }
        else{
            type="daily"
          }
        return { start, end, repeat, task, type, duration }
      });
    },
    getDurationTask(index){
      let clips = this.getClips()
      let clipsLength = clips.length
      let dayLength = 24*60
      let playedRanges = multirange();

      let taskRealDuration = {};

      for(let i = clipsLength - 1; i >= 0; i--) {
          let currentClip = clips[i];
          let taskRanges = multirange();
          if(currentClip.repeat == null) {
              if(currentClip.start > currentClip.end) {
                  taskRanges.add(range(0, currentClip.end));
                  taskRanges.add(range(currentClip.start, dayLength));
              } else {
                  taskRanges.add(range(currentClip.start, currentClip.end));
              }
          } else {
              for(let offset = currentClip.start; offset < dayLength; offset+=currentClip.repeat) {
                  taskRanges.add(range(offset, offset + currentClip.duration));
              }
          }
          /* sum of all ranges */
          let timePlayed = taskRanges.ranges.reduce((sum, range) => {
              return sum + (range.end - range.start);
          }, 0);
          /** intersection with previous ranges */
          let overlappedRanges = playedRanges.intersect(taskRanges);
          /** sum time in overlapped ranges */
          let timeOverlapped = overlappedRanges.reduce((sum, interval) => {
              return sum + (interval[1] - interval[0]);
          }, 0);
          playedRanges.add(taskRanges);
          taskRealDuration[i] = timePlayed - timeOverlapped;

      }
      return taskRealDuration[index];
    },
    formatTask:function(index){
      let durationPlaylist = `0 минут`;
      let durationTask;
      let t
      t = this.schedule.tasks[index];
      durationTask = this.getDurationTask(index)
      let formatDurationTask = formatAmountMinutes(durationTask)
      this.tDuration = formatDurationTask
      if(t instanceof PlaylistTask) {
        if (t instanceof SlideshowTask || t instanceof DocumentTask){
          let duration = t.playlist.length*t.delay
          this.tDuration = duration
          console.log(`Image duration: ${duration}`)
          let dsec = duration % 60;
          let dmin = Math.floor(duration / 60);
          console.log(dmin)
          console.log(dsec)
          durationPlaylist = formatAmountMinutesSeconds(dmin,dsec)
          console.log(`Image duration playlist: ${duration}`)
        }
        else if (t instanceof VideoTask){
          if (this.files.length>0){
            let duration = t.calculateDuration(this.files);
            this.tDuration = duration
            console.log(`Video duration: ${duration}`)
            let dsec = duration % 60;
            let dmin = Math.floor(duration / 60);
            durationPlaylist = formatAmountMinutesSeconds(dmin,dsec)
          }
        }
      }
      return {
        icon: this.getTaskIcon(t),
        taskName: t.taskName,
        label:t.label,
        durationPlaylist: durationPlaylist,
        durationTask: formatDurationTask,
        isDefault: t.schedule instanceof DefaultSchedule,
        schedule: t.schedule.toString(),
        realTask: t
      }
    },
    openStatisticsWindow(index){
      this.selectedTaskIndex = index;
      console.log('selected', this.selectedTaskIndex)
      if (index>=this.schedule.tasks.length){
        this.openStatistics=false;
      } else{
        this.currentStatisticsTask = this.schedule.tasks[index]
        this.currentTask = this.formatTask(index)
        this.openStatistics=true;
      }
    },
    closeStatisticsWindow(){
      this.openStatistics=false;
    },
    setHighlight(index) {
      if (index!==null && index<=this.schedule.tasks.length-1){
        this.highlightedTask = index;
      }
    },
    unsetHighlight(index) {
      if(this.highlightedTask === index)
        this.highlightedTask = null;
    },
    openTaskByIndex(index) {
      this.openTask(this.schedule.tasks[index], index);
    },
    unloadHandler(e) {
      if(this.scheduleUpdated){
        e.preventDefault()
      }
    },
    async fetchSchedule() {
        try {
            let schedule = await this.schedulesAPI.read(this.currentSchedule);
            this.schedule.import(schedule.schedule);
            this.title = schedule.name;
        } catch(e) {
            console.warn('Failed to load schedule')
        }
    },
    async fetchFiles() {
        try {
          this.files = await this.filesAPI.fetch();
        } catch(e) {
          console.warn('Failed to load files')
        }
    },
    getTaskIcon(task) {
        if(task instanceof VideoTask) {
          return require('@/assets/imgs/playlist/type-video.svg')
        } else if(task instanceof SlideshowTask) {
          return require('@/assets/imgs/playlist/slideshow.svg')
        } else if(task instanceof DocumentTask) {
          return require('@/assets/imgs/playlist/document.svg')
        } else if(task instanceof StreamTask) {
          return require('@/assets/imgs/playlist/type-stream.svg')
        } else if(task instanceof WebTask) {
          return require('@/assets/imgs/playlist/type-web.svg')
        } else if(task instanceof SleepTask) {
          return require('@/assets/imgs/playlist/type-monitor.svg')
        }
    },
    isPlaylist(task) {
      return task instanceof PlaylistTask
    },
    updateTask(task, index) {
      try {
        this.schedule.updateTask(index, task);
        this.scheduleUpdated = true;
        this.saveSchedule()
      } catch(e) {
        this.messagePopup.show('Ошибка при настройке задачи: ' + e.toString());
        this.openTask(task, index);
      }
    },
    openTask(task, index) {
      if(task instanceof PlaylistTask) {
        this.openModal('editPlaylistModal', { index, task });
      } else if(task instanceof URLTask) {
        this.openModal('editURLModal', { index, task });
      } else {
        this.openModal('editSleepModal', { index, task });
      }
    },
    removeTask(item) {
      this.schedule.removeTask(item);
      this.scheduleUpdated = true;
      this.saveSchedule()
    },
    decreasePriority(index){
      this.schedule.decreaseTaskPriority(index);
      this.scheduleUpdated = true;
      this.saveSchedule()
    },
    increasePriority(index){
      this.schedule.increaseTaskPriority(index);
      this.scheduleUpdated = true;
      this.saveSchedule()
    },
    createTask(task) {
      if(this.schedule.hasDefaultTask) {
        task.schedule = new PlayUntilTime(new DailyTime(0, 0), new DailyTime(12, 0))
      }
      if((task instanceof SlideshowTask) || (task instanceof DocumentTask)){
        task.delay = 10;
      }
      let taskIndex = this.schedule.addTask(task);
      this.scheduleUpdated = true;
      this.openTask(task, taskIndex);
    },
    async saveSchedule() {
        try {
          await this.schedulesAPI.save(this.currentSchedule, this.schedule.export());
          this.scheduleUpdated = false;
        } catch(e) {
          this.messagePopup.show('Не удалось сохранить расписание');
        } finally {
          this.fetchSchedule();
        }
    },
    async leaveWithoutSave(next) {
      next()
    },
  },
  setChartWidth(chartWidth){
    console.log(chartWidth)
    this.chartWidth = chartWidth;
  }
}
</script>
<style scoped>
  .modal_container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: black;
    opacity: .7;
    z-index: 1;
  }
	.main_content {
		width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
	}

  .sidebar-container{
    height: 100%;
    width:15%;
    position:sticky;
  }
	.main_content .content {
		display: flex;
    flex-direction: row;
		align-items: flex-start;
		padding: 5px 0 0 10px;
    width: 100%;
    flex-grow: 1;
	}
	table th {
		font-weight: 400;
		font-size: 18px;
		padding: 0 10px 10px 10px;
		text-align: center;
	}
	table td {
		text-align: center;
		padding: 0 10px;
	}
	table td {
		margin: 8px 0;
	}
	.btns {
		display: flex;
		align-items: center;
    justify-content: end;
	}
  .icons {
    cursor: pointer;
  }
  .title-list {
    display: flex;
    flex-direction: column;
    padding: 10px;
    min-height: 56px;
    text-align: left;
    font-size: 14px;
  }
  .title-list .title {
    font-weight: bold;
  }
  .calendar-block {
    width: 70px;
  }
  .list-item-buttons {
    display: flex;
  }

  #changeName {
    text-align: left;
    width: 100%;
    padding: 10px;
    padding-left: 0px;
    font-size: 16px;
    border: 0;
    outline: none;
  }
  .title_row {
    width: 100%;
  }
  .title-list .info_list {
    font-size: 14px;
    font-weight: 400;
  }
  .list-item {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 5px;
    box-sizing: border-box;
    cursor: pointer;
    border: none !important;
    height: 160px;
  }
  .chart-container {
    padding: 0;
    overflow: hidden;
    flex-grow: 1;
  }
  .editor-column {
    display: flex;
    flex-direction: column;
    padding-top: 40px;
  }
  .editor-column-info > .list-item {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 10px;
  }
  .editor-column > .list-item:first-child {
  }
  .editor-column > .list-item > .list-item-icon {
    width: 48px;
    height: 48px;
    align-self: flex-start;
  }
  .editor-column > .list-item > .list-item-caption {
    padding: 5px;
    font-size: 10pt;
    min-height: auto;
    flex-grow: 0;
    white-space: nowrap;
  }
  .editor-column-actions > .list-item {
    flex-direction: row;
  }
  .schedule-name{
    text-align: center;
    margin-top:20px;
    margin-bottom:25px;
  }
</style>
